import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";

const StackedSidebar = () => {
  const routes = all_routes;

  return (
    <div className="stacked-sidebar" id="stacked-sidebar">
      <div className="sidebar sidebar-stacked" style={{ display: "flex" }}>
        <div className="stacked-mini">
          <Link to={routes.adminDashboard} className="logo-small">
            <ImageWithBasePath src="assets/img/logo-small.svg" alt="Logo" />
          </Link>
          <div className="sidebar-left slimscroll">
            <div className="d-flex align-items-center flex-column">
              <div className="mb-1 notification-item">
                <Link
                  to={routes.activity}
                  className="btn btn-menubar position-relative"
                >
                  <i className="ti ti-bell"></i>
                  <span className="notification-status-dot"></span>
                </Link>
              </div>
              <div className="mb-1">
                <Link to="#" className="btn btn-menubar btnFullscreen">
                  <i className="ti ti-maximize"></i>
                </Link>
              </div>
              <div className="mb-1">
                <Link to="#" className="btn btn-menubar position-relative">
                  <i className="ti ti-shopping-bag"></i>
                  <span className="badge bg-success rounded-pill d-flex align-items-center justify-content-center header-badge">
                    5
                  </span>
                </Link>
              </div>
              <div className="mb-1">
                <Link to={routes.calendar} className="btn btn-menubar">
                  <i className="ti ti-layout-grid-remove"></i>
                </Link>
              </div>
              <div className="mb-1">
                <Link
                  to={routes.chat}
                  className="btn btn-menubar position-relative"
                >
                  <i className="ti ti-brand-hipchat"></i>
                  <span className="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge">
                    5
                  </span>
                </Link>
              </div>
              <div className="mb-1">
                <Link to={routes.email} className="btn btn-menubar">
                  <i className="ti ti-mail"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="sidebar-right d-flex justify-content-between flex-column">
          <div className="sidebar-scroll">
            <h6 className="mb-3">Welcome to Nssoft tech Finance</h6>

          </div>
        </div>
      </div>
    </div>
  );
};

export default StackedSidebar;
